import axios from "axios";
import { toast } from "react-toastify";
import { sessionManager } from "../utils/sessionManager";
import { ADMIN_API_BASE_URL } from "../utils/runtimeConfig";

const api = axios.create({
  baseURL: ADMIN_API_BASE_URL,
  withCredentials: true,
});

const getEstabelecimentoHeader = () => {
  try {
    const fromStorage = localStorage.getItem("estabelecimento_id");
    if (fromStorage) return String(fromStorage);

    const usuario = sessionManager.obterUsuario();
    if (usuario?.estabelecimento_id) {
      return String(usuario.estabelecimento_id);
    }
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("[API] Falha ao resolver estabelecimento da sessão:", error?.message);
    }
  }

  return null;
};

const isAuthFailure = (error) => {
  const status = error.response?.status;
  if (status !== 401 && status !== 403) return false;

  const message = String(
    error.response?.data?.error ||
      error.response?.data?.mensagem ||
      ""
  ).toLowerCase();

  return message.includes("token") || message.includes("autentic");
};

api.interceptors.request.use((config) => {
  const estabelecimentoId = getEstabelecimentoHeader();
  if (estabelecimentoId) {
    config.headers["X-Estabelecimento-Id"] = estabelecimentoId;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config || {};
    const requestUrl = String(config.url || "");

    if (
      isAuthFailure(error) &&
      !config._retry &&
      sessionManager.estaAutenticado() &&
      !requestUrl.includes("/auth/renovar") &&
      !requestUrl.includes("/auth/login") &&
      !requestUrl.includes("/auth/logout")
    ) {
      config._retry = true;

      try {
        await axios.post(
          `${ADMIN_API_BASE_URL}/auth/renovar`,
          {},
          { withCredentials: true }
        );
        return api(config);
      } catch (refreshError) {
        sessionManager.limparSessao({ silent: true });
        window.dispatchEvent(new CustomEvent("session:ended", { detail: { reason: "refresh_expired" } }));
        return Promise.reject(refreshError);
      }
    }

    if (error.response?.status === 402) {
      const code = error.response?.data?.code;
      const mensagem = error.response?.data?.mensagem;
      if (code === "ASSINATURA_SOMENTE_LEITURA") {
        toast.warning(mensagem || "Modo leitura: escolha um plano para liberar alterações.", {
          toastId: "fz-assinatura-leitura",
        });
      } else if (code === "ASSINATURA_REQUERIDA") {
        toast.warning(mensagem || "Escolha ou regularize um plano para continuar.", {
          toastId: "fz-assinatura-requerida",
        });
      }
    }

    return Promise.reject(error);
  }
);

export default api;
